const TELEGRAM_BOT = "authckino_bot"
const TELEGRAM_START = "1"

export function getTelegramAppUrl() {
    return `tg://resolve?domain=${TELEGRAM_BOT}&start=${TELEGRAM_START}`
}

export function getTelegramWebUrl() {
    return `https://t.me/${TELEGRAM_BOT}?start=${TELEGRAM_START}`
}

function isMobileDevice() {
    return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
}

function isIOS() {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent)
}

function isAndroid() {
    return /Android/i.test(navigator.userAgent)
}

function isDesktop() {
    return !isMobileDevice()
}

function openTelegramInBrowser(webUrl: string) {
    window.open(webUrl, "_blank", "noopener,noreferrer")
}

/** Клик по скрытой ссылке — не выгружает текущую страницу (в отличие от location.assign). */
function openTelegramViaAnchor(url: string) {
    const link = document.createElement("a")
    link.href = url
    link.style.display = "none"
    document.body.appendChild(link)
    link.click()
    link.remove()
}

function tryOpenTelegramApp(appUrl: string) {
    openTelegramViaAnchor(appUrl)
}

function openTelegramWithFallback(appUrl: string, webUrl: string) {
    let appOpened = false

    const cleanup = () => {
        appOpened = true
        window.clearTimeout(fallbackId)
        document.removeEventListener("visibilitychange", onAppOpened)
    }

    const onAppOpened = () => {
        // Системный диалог macOS/Windows не скрывает вкладку — не считаем это успехом.
        // Fallback отменяем только когда пользователь реально перешёл в приложение.
        if (document.hidden) cleanup()
    }

    const fallbackMs = isDesktop() ? 5000 : 2500

    const fallbackId = window.setTimeout(() => {
        if (appOpened) return
        cleanup()
        openTelegramInBrowser(webUrl)
    }, fallbackMs)

    document.addEventListener("visibilitychange", onAppOpened)
    tryOpenTelegramApp(appUrl)
}

export function openTelegramBot() {
    const appUrl = getTelegramAppUrl()
    const webUrl = getTelegramWebUrl()

    if (isAndroid()) {
        const intentUrl = `intent://resolve?domain=${TELEGRAM_BOT}&start=${TELEGRAM_START}#Intent;scheme=tg;package=org.telegram.messenger;S.browser_fallback_url=${encodeURIComponent(webUrl)};end`
        window.location.href = intentUrl
        return
    }

    if (isIOS()) {
        // tg:// из обработчика клика: открывает приложение, страница остаётся загруженной.
        openTelegramViaAnchor(appUrl)
        return
    }

    // macOS, Windows, Linux: tg:// + fallback на t.me
    openTelegramWithFallback(appUrl, webUrl)
}
